export default "__VITE_PUBLIC_ASSET__625bd398__"